import { Snowflake, Wifi, ParkingSquare, DoorOpen, CircleCheckBig } from "lucide-react";

const features = [
  { icon: CircleCheckBig, label: "Fully furnished office" },
  { icon: Snowflake, label: "Heating / Air-conditioning" },
  { icon: `${process.env.PUBLIC_REMIX_APP_ASSESTS_IMAGES}/assets/icons/soup-kitchen-outlined.svg`, label: "Breakout areas and kitchens" },
  { icon: DoorOpen, label: "Meeting rooms" },
  { icon: Wifi, label: "High-speed Internet" },
  { icon: ParkingSquare, label: "Parking facilities" },
  { icon: `${process.env.PUBLIC_REMIX_APP_ASSESTS_IMAGES}/assets/icons/boy-outlined.svg`, label: "Office staff" },
  { icon: `${process.env.PUBLIC_REMIX_APP_ASSESTS_IMAGES}/assets/icons/cleaning-services-outlined.svg`, label: "Maintenance and office management" },
];

export default function SpaceTypeAmenities() {
  return (
    <div className="rounded-md border border-gray-50 bg-white overflow-hidden">
      <div className="grid grid-cols-2 lg:grid-cols-4 divide-x divide-y divide-gray-50">
        {features.map(({ icon: Icon, label }) => (
          <div key={label} className="p-8">
            <div className="mx-auto max-w-[255px] flex flex-col items-center text-center gap-3">
              <div className="h-12 w-12 rounded-lg bg-gray-50 flex items-center justify-center">
                {typeof Icon === 'string' ? (
                  <div className='flex h-12 w-12 items-center justify-center rounded-lg bg-gray-50'>
                    <img src={Icon} alt={label} className='h-8 w-8 object-contain' />
                  </div>
                ) : (
                  <div className='flex h-12 w-12 items-center justify-center rounded-lg bg-gray-50 text-oh-black'>
                    <Icon className='h-8 w-8' />
                  </div>
                )}
              </div>
              <p className="text-sm text-oh-black">{label}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}